export default __webpack_public_path__ + "static/screenshot-mybiz-2-ed600174fe542debb8f2c231ffb7ba07.jpg";